import { render, staticRenderFns } from "./PlaylistSlide.vue?vue&type=template&id=c044b07e&scoped=true"
import script from "./PlaylistSlide.vue?vue&type=script&lang=js"
export * from "./PlaylistSlide.vue?vue&type=script&lang=js"
import style0 from "./PlaylistSlide.vue?vue&type=style&index=0&id=c044b07e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c044b07e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c044b07e')) {
      api.createRecord('c044b07e', component.options)
    } else {
      api.reload('c044b07e', component.options)
    }
    module.hot.accept("./PlaylistSlide.vue?vue&type=template&id=c044b07e&scoped=true", function () {
      api.rerender('c044b07e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/PlaylistSlide.vue"
export default component.exports